var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sj-panel-month"},_vm._l((_vm.dateList),function(dateItem){return _c('div',{key:dateItem.date,class:[
      'sj-panel-month-item',
      {
        current: dateItem.current
      }
    ],on:{"click":function($event){return _vm.handleClick(dateItem)},"mouseenter":function($event){return _vm.handleMouseenter(dateItem)}}},[_c('div',{class:[
        'sj-panel-month-item-inner',
        {
          'is-range': _vm.getItemIsRange(dateItem),
          'start-date': _vm.getItemIsStartOrEndDate(dateItem),
          'end-date': _vm.getItemIsStartOrEndDate(dateItem, 'end'),
          selected: _vm.getItemSelected(dateItem)
        }
      ]},[_c('span',[_vm._v(_vm._s(dateItem.label))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }